import {SELECT_ALL,SELECT_ONE } from '../actionType/type';

export const selectAll = (checked) => async (dispatch) => {
    return dispatch({ type: SELECT_ALL, payload: checked  })
}

export const checkOne = (email, checked) => async (dispatch) => {
    return dispatch({ type: SELECT_ONE, payload: { email, checked } })
}

